<template>
  <div class="buy-dialog">
    <h2 class="buy-title">{{title}}</h2>
    <ul class="buy-list">
      <li :key="index" class="buy-item" v-for="(item, index) in list">
        <item v-bind="$bus.formatData(item)" />
        <c-marquee class="buy-item-name" :is-ar="$bus.isAr">{{item.item_name}}</c-marquee>
      </li>
    </ul>
    <div class="buy-cost">
      <span class="real-cost gem">{{totalRealCost}}</span>
      <span class="current-cost">{{totalCost}}</span>
    </div>
  </div>
</template>
<script>
  import Item from '@/components/item/item'
  export default {
    name: 'BuyItems',
    data() {
      return {
        totalCost: 0,
        totalRealCost: 0
      }
    },
    props: {
      title: String,
      list: Array
    },
    components: {
      Item
    },
    watch: {
      list: {
        immediate: true,
        handler(data) {
          const result = data.reduce(
            (acc, cur) => {
              return {
                cost: acc.cost + cur.cost,
                realCost: acc.realCost + cur.realCost
              }
            },
            { cost: 0, realCost: 0 }
          )
          this.totalCost = result.cost
          this.totalRealCost = result.realCost
        }
      }
    }
  }
</script>
<style lang="scss">
  .buy-dialog {
    .buy-title {
      @include px2res(padding, 65, 0, 15);
      @include px2res(font-size, 48);
    }
    .buy-list {
      @include flexrc;
    }
    .buy-item {
      @include px2res(margin-right, 40);
      &:last-child {
        margin-right: 0;
      }
      .buy-item-name {
        line-height: 1.2;
        @include px2res(margin-top, 4);
        @include px2res(width, 104);
        @include px2res(font-size, 30);
        color: #d1e9ed;
      }
    }
    .buy-cost {
      @include px2res(margin, 12, 0, 10);
      .real-cost {
        @include px2res(font-size, 35);
        &.gem::before {
          @include px2res(width, 27);
          @include px2res(height, 22);
        }
      }
      .current-cost {
        @include px2res(font-size, 27);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/buy-items/buy-items.vue